<template>
  <div>
    <BalanceBatteryCellsDialog
      :isOpen="cellsDialog"
      :cells="balancedCells"
      :closeDialog="closeDialog"
      :createBattery="adjustCellsInBattery"
      :replaceCell="replaceCell"
      :sort="sort"
      :sorted="sorted"
    />
    <!-- <BatchBalanceForm :warranties="warranties" :refreshList="refreshList" /> -->
    <v-divider></v-divider>
    <CreateBalanceBatteryForm
      :warranties="warranties"
      :updateBalancedCells="updateBalancedCells"
    />
    <v-tabs :value="activeTab">
      <v-tabs-slider></v-tabs-slider>

      <v-tab @click="activeTab = 0">Summary</v-tab>
      <v-tab @click="activeTab = 1">Group Cells</v-tab>
      <v-tab @click="activeTab = 2">Cells</v-tab>
      <v-tab @click="activeTab = 3">Create Battery</v-tab>
      <v-tab @click="activeTab = 4">ReUse Cells</v-tab>

      <v-tab-item>
        <div v-if="activeTab === 0 && !loading">
          <BalancedSummary
            :warrantyRanges="warrantyRanges"
            :warranties="warranties"
          />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div v-if="activeTab === 1 && !loading">
          <BalancedGroup />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div v-if="activeTab === 2 && !loading">
          <BalancedCells />
        </div>
      </v-tab-item>
  
      <v-tab-item>
        <CreateBalancedBattery
          :cells="voltageAdjustedCells"
          :activeTab="activeTab"
          :batteryNumber="batteryNumber"
        />
      </v-tab-item>
            <v-tab-item>
        <div v-if="activeTab === 4 && !loading">
          <ReuseBalancedCells />
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
const sortkey = "power"
import BalancedSummary from "./BalancedSummary.vue";
// import BatchBalanceForm from "./BatchBalanceForm.vue";
import CreateBalanceBatteryForm from "./CreateBalanceBatteryForm.vue";
import CreateBalancedBattery from "./CreateBalancedBattery.vue";
import BalancedGroup from "./BalancedGroup.vue";
import BalancedCells from "./BalancedCells.vue";
import ReuseBalancedCells from "./ReuseBalancedCells.vue";
import BalanceBatteryCellsDialog from "./BalanceBatteryCellsDialog.vue";
import ranges from "./ranges.json";
import { balancedcells } from "@/api";
import { cloneDeep } from "lodash";

export default {
  name: "Batteries",
  components: {
    BalancedSummary,
    // BatchBalanceForm,
    BalancedGroup,
    BalancedCells,
    ReuseBalancedCells,
    CreateBalanceBatteryForm,
    CreateBalancedBattery,
    BalanceBatteryCellsDialog,
  },
  data: () => ({
    activeTab: 0,
    loading: false,
    cellsDialog: false,
    cellsPowerList: [],
    sorted: 0,
    cellsWarrantyList: [
      {
        warranty: "2 Years",
        range: ranges['2years'],
        count: 0
      },
      {
        warranty: "1 Year",
        range: ranges["1year"],
        count: 0,
      },
      {
        warranty: "6 Months",
        range: ranges["6months"],
        count: 0,
      },
      {
        warranty: "45 Days",
        range: ranges["45days"],
        count: 0,
      },
      {
        warranty: "Total",
        range: [ranges["45days"][0], ranges["1year"][1]],
        count: 0,
      },
    ],
    warrantyRanges: ranges,
    warranties: [
      { value:"2year", text: "2 Year" },
      { value:"1year", text: "1 Year" },
      { value:"6months", text: "6 Months" },
      { value:"45days", text: "45 Days" },
      { value:"others", text: "Others" },
      { value:"custom", text: "Custom" }
    ],
    balancedCellsCopy: [],
    balancedCells: [],
    voltageAdjustedCells: [],
    batteryNumber: 0,
    balancedCellsBody: {},
  }),
  methods: {
    sort() {
      if(this.sorted === 0) {
        this.balancedCells = cloneDeep(this.balancedCells).sort((a, b) => b[sortkey] - a[sortkey] )
        this.sorted = -1;
      } else if(this.sorted === -1) {
        this.balancedCells = cloneDeep(this.balancedCells).sort((a, b) => a[sortkey] - b[sortkey] )
        this.sorted = 1;
      } else {
        this.balancedCells = cloneDeep(this.balancedCellsCopy);
        this.sorted = 0;
      }
    },
    changeTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    updateBalancedCells(cells, battery, data) {
      this.balancedCells = cells;
      this.balancedCellsCopy = cloneDeep(cells);
      this.batteryNumber = battery;
      this.balancedCellsBody = data;
      this.cellsDialog = true;
    },
    closeDialog() {
      this.cellsDialog = false;
      this.balancedCells = [];
    },
    adjustCellsInBattery() {
      this.cellsDialog = false;
      this.activeTab = 3;
      this.voltageAdjustedCells = this.$clone(this.balancedCells);
      this.balancedCells = [];
    },
    async replaceCell(cell) {
      try {
        const confirm = await this.$alert.confirm({
          confirmButtonText: "Yes, replace it!",
          title: `Replace Cell Number ${cell.number} ?`,
          text: "You won't be able to revert this!",
        });
        if (confirm && confirm.value === true) {
          const { data } = await balancedcells.replaceCell(
            cell.number,
            this.balancedCellsBody
          );
          this.balancedCells = data.cells;
          this.balancedCellsCopy = cloneDeep(data.cells);
          this.batteryNumber = data.batteryNumber;
        }
      } catch (error) {
        this.$toast.error("No Cell Found");
      }
    },
    refreshList() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 100);
    },
  },
};
</script>